
import store from '../index.js'
import api from '../../utils/api'

export const modules = ({
    store
})

export const state = ({
    _auth: {},
    _items: [],
    _progress: []
});


export const mutations = {  
    setCreditSci(state, item){
        state._auth = {};
        if(item){
            let dateTime = new Date(item.modifyDate.replace('T', ' ').replace('.000Z', ''));
            let dateHour = new Date(item.modifyDate.replace('T', ' ').replace('.000Z', '')).getHours() + 9
            item.modifyDate = new Date(dateTime.setHours(dateHour)).toLocaleString();
        }
        state._auth = item;
    },
    setCreditProcess(state, items){
        state._items = [];
        state._items = items;
    },
    setCreditProgress(state, items){
        state._progress = [];
        state._progress.user = items;
    },
    setCreditReset(state){
        state._auth = {};
        state._items = [];
        state._progress = [];        
    },
    setCreditProgressReset(state){
        state._progress = [];     
    }
};


export const actions = {
    async acCreditSci({commit}, email){
        try{
            const result = await api.get(`/api/v1/credit-sci/user/email?email=${email}`);
            if(result?.data?.code === 0 && result?.data?.data){
                commit('setCreditSci', result.data?.data);
                return true;
            }                        
            return false;
        }
        catch(err){
            console.log('err', err.message);
            return false;
        }  
    },
    async acCreditReport({commit}, userno){
        try{
            const result = await api.get(`/api/v1/credit-sci/report/info/${userno}`);
            if(result?.data?.code === 0){
                commit('setCreditProcess', result.data?.data)
            }                        
        }
        catch(err){
            console.log('err', err.message);
            return false;
        }  
    },
    async acCreditProgress({commit}, seq){
        try{
            const result = await api.get(`/api/v1/credit-sci/report/progress/${seq}`);
            if(result?.data?.code === 0){
                commit('setCreditProgress', result.data?.data)
            }                        
        }
        catch(err){
            console.log('err', err.message);
            return false;
        }  
    },
    acCreditReset({commit}){
        commit('setCreditReset');
    },
    acCreditProgressReset({commit}){
        commit('setCreditProgressReset');
    },
    async acResetSci({commit}, seq){
        try{
            const result = await api.post(`/api/v1/credit-sci/report/reset/${seq}`);
            if (result?.data?.code === 0 && result?.data?.data?.affected !== 0) {
                return true;
            }
            return false
        }
        catch(err){
            console.log('err', err.message);
            return false;
        }
    },
};


export const getters = {

};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}